import type { AxiosInstance } from "axios"

class CircleImportClient {
	constructor(private axiosClient: AxiosInstance) {}

	public uploadMissingTenantPatientIds = (file: File) =>
		this.axiosClient.postForm("/api/admin/import/circle/clientpatientid", {
			files: [file]
		})
}

class SpireImportClient {
	constructor(private axiosClient: AxiosInstance) {}

	public uploadMissingEpisodeNumber = (file: File) =>
		this.axiosClient.postForm("/api/admin/import/spire/episodenumbers", {
			files: [file]
		})

	public uploadMissingClientPatientIds = (file: File) =>
		this.axiosClient.postForm("/api/admin/import/spire/clientpatientid", {
			files: [file]
		})
}

export class ImportClient {
	constructor(private axiosClient: AxiosInstance) {
		this.circle = new CircleImportClient(axiosClient)
		this.spire = new SpireImportClient(axiosClient)
	}

	public circle: CircleImportClient
	public spire: SpireImportClient

	public startConsultantEmailsUpload = (file: File) =>
		this.axiosClient.postForm("/api/admin/extracts/consultantemails", {
			files: [file]
		})

	public uploadPatientNhsNumbers = (file: File) =>
		this.axiosClient.postForm("/api/admin/import/nhsnumbers", {
			files: [file]
		})
}
